import { jsx as o } from "react/jsx-runtime";
import { TextInput as e } from "flowbite-react";
import { forwardRef as m } from "react";
import { theme as p } from "./theme.js";
const f = m(
  (t, r) => /* @__PURE__ */ o(e, { theme: p, ...t, ref: r })
);
f.displayName = "TextInput";
export {
  f as TextInput
};
